import { GenerateUserGuestResponse } from "src/api/services/storeFront/storeFront";
import { getTokenTools } from "src/api/services/tokenTools/tokenToolsApi";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { isLocal } from "./BasePathTools";
import { ZARA_COOKIES_KEYS } from "./constants";
import { createCookie, getValueCookie } from "./cookies";

let tokens: {
  token: string;
  guestToken: string;
  WCToken: string;
  WCTrustedToken: string;
} = null;
export type TokensType = {
  token: string;
  guestToken: string;
  WCToken: string;
  WCTrustedToken: string;
};
export async function searchToken(): Promise<TokensType> {
  if (isLocal && !tokens) {
    tokens = await getTokenTools();
  }
  return tokens;
}

export function getToken(): TokensType {
  return tokens;
}

export function getAuthHeader(): Record<string, string> {

  const accessToken = getUserFromCookies().accessToken;

  if (accessToken) {
    return { Authorization: `Bearer ${accessToken}` };
  } else {
    return {};
  }
}

export function getUserFromCookies(): Record<string, string> {
  const { shopId } = useShop();

  const userType = getValueCookie(ZARA_COOKIES_KEYS.USER_TYPE);

  const userId = getValueCookie(ZARA_COOKIES_KEYS.USER_ID);

    const accessToken = document.cookie
    .split("; ")
    .find(
      (row) =>
        row.startsWith(`${ZARA_COOKIES_KEYS.ACCES_TOKEN}@${shopId}`) ||
        (row.startsWith(ZARA_COOKIES_KEYS.ACCES_TOKEN) &&
          !row.startsWith(`access_token_expires`) &&
          !row.includes("@")),
    )
    ?.split("=")[1];
    
    return { user_type: userType || undefined, user_id: userId || undefined, accessToken: accessToken || undefined };

}

export function existGuestUser(): Record<string, string> {
  const user = getUserFromCookies();

  if (user?.user_type === "guest") {
    return user;
  }

  return null;
}

export function registerUserCookies(guestResponse: GenerateUserGuestResponse): void {
  const expirateDate = new Date(Date.now() + 86400000).toUTCString();
  createCookie(ZARA_COOKIES_KEYS.USER_ID, guestResponse.user_details.user_id, 86400);
  createCookie(ZARA_COOKIES_KEYS.USER_TYPE, 'guest', 86400);
  createCookie(ZARA_COOKIES_KEYS.ACCES_TOKEN, guestResponse.access_token, 86400);
  createCookie(ZARA_COOKIES_KEYS.ACCES_TOKEN_EXPIRES, encodeURIComponent(expirateDate), 86400);
}